import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";

import ManualProvider from "./Manual/ManualProvider";
import PlaidProvider from "./Plaid/PlaidProvider";
import VezgoProvider from "./Vezgo/VezgoProvider";
import TellerProvider from "./Teller/TellerProvider";
import SnaptradeProvider from "./Snaptrade/SnaptradeProvider";

import Loader from "../components/Loader/Loader.component";

import { ThemeProvider } from "@mui/material/styles";
import { Box, Paper, Button, CssBaseline, GlobalStyles } from "@mui/material";

import { createProviderLinkOnFailure } from "../helpers/webViewCallback";

import darkTheme from "../theme/theme.dark";
import lightTheme from "../theme/theme.light";
import { callBackendAPI } from "../helpers/api";

const providerMap = {
  manual: ManualProvider,
  plaid: PlaidProvider,
  vezgo: VezgoProvider,
  teller: TellerProvider,
  snaptrade: SnaptradeProvider,
};

function Provider() {
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const [providerInfo, setProviderInfo] = useState(null);
  const [providerId, setProviderId] = useState("");
  const [token, setToken] = useState("");
  const [user, setUser] = useState(null);

  useEffect(() => {
    const res =
      searchParams.get("providerId") || localStorage.getItem("providerId");
    setProviderId(res);
    localStorage.setItem("providerId", res);

    const res1 =
      searchParams.get("token") || localStorage.getItem("api_token") || "";
    localStorage.setItem("api_token", res1);
    setToken(res1);

    if (
      localStorage.getItem("user") &&
      localStorage.getItem("user") !== undefined
    ) {
      !user && setUser(JSON.parse(localStorage.getItem("user")));
    }

    if (res1) {
      fetchUserProfile();
    }
  }, []);

  const fetchUserProfile = async () => {
    try {
      const userProfileResp = await callBackendAPI({
        path: `/web/users/me`,
        method: "GET",
      });

      console.log(userProfileResp, "user pro");

      setUser(userProfileResp);
      localStorage.setItem("user", JSON.stringify(userProfileResp));
      window.analytics.identify(userProfileResp.id, {
        email: userProfileResp.email,
        platform: "providerLink",
      });
      window.analytics.page();
      window.analytics.track("provider_link_init", {
        providerInfo: providerInfo,
      });
    } catch (err) {
      console.log(err);
    }
  };

  const mode = searchParams.get("mode") || localStorage.getItem("redirect");
  const walletId = searchParams.get("walletId");
  const redirectURL =
    searchParams.get("redirect") || localStorage.getItem("redirect");
  //web or mobile - to perform different actions for future
  const source = searchParams.get("source") || localStorage.getItem("source");

  localStorage.setItem("redirect", redirectURL);
  localStorage.setItem("mode", mode);

  // localStorage.setItem("providerId", providerId);
  localStorage.setItem("source", source);

  const themeMemo = useMemo(() => {
    const theme = searchParams.get("theme") || localStorage.getItem("theme");
    localStorage.setItem("theme", theme);
    return theme === "dark" ? darkTheme : lightTheme;
  }, [searchParams]);

  useEffect(() => {
    if (token && providerId) calculateProviders();
  }, [providerId, token]);

  const calculateProviders = async () => {
    if (!providerId) {
      return;
    }
    try {
      const providerData = await callBackendAPI({
        path: `/provider_link/provider?provider_id=${providerId}`,
        method: "GET",
      });
      if (!providerData || !providerData.id) {
        createProviderLinkOnFailure({
          message: "Something went wrong please try again",
        });
      }
      if (window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler(
          "providerInfo",
          JSON.stringify(providerData)
        );
        setProviderInfo(providerData);
        providerData &&
          localStorage.setItem("provider_info", JSON.stringify(providerData));
        providerData &&
          sessionStorage.setItem("provider_info", JSON.stringify(providerData));
      } else {
        setProviderInfo(providerData);
        localStorage.setItem("provider_info", JSON.stringify(providerData));
      }

      providerId &&
        window.history.replaceState(null, "", `/?providerId=${providerId}`);
      console.log(token, "Token");

      setIsLoading(false);
      console.log(providerData, "provider data");
    } catch (err) {
      console.log(err, "err");
    }
  };

  const ProviderComponent = useMemo(() => {
    if (!isLoading && providerInfo) {
      console.log(providerInfo, "provider indo");
      return providerMap[
        providerInfo.platform
        //  ? providerInfo.platform : providerInfo.wallet_type
      ];
    }
    return Loader;
  }, [isLoading]);

  useEffect(() => {
    if (!token) {
      return;
    }
  }, [token]);

  //TODO: add loader till the pop up opens

  // console.log("---------------");
  // console.log("Token: ", token);

  // Set token for use later

  // if (!ProviderComponent) return <div>Not found</div>;

  const setLoading = (bool) => {
    setIsLoading(bool);
  };

  return (
    <ThemeProvider theme={themeMemo}>
      <CssBaseline />
      <Box className="App">
        {isLoading ? (
          <Loader />
        ) : (
          <ProviderComponent
            providerData={providerInfo}
            mode={mode}
            walletId={walletId}
            setLoading={setLoading}
          />
        )}
      </Box>
    </ThemeProvider>
  );
}

export default Provider;
